import { Route } from 'react-router-dom';

import { SettingsAIOptionsStyleGuideView } from './settingsAIOptionsStyleGuide.view';
import { SettingsAIOptionsStyleGuideCreateView } from './views/create';
import { SettingsAIOptionsStyleGuideEditView } from './views/edit';

export const settingsAIOptionsStyleGuideRoutes = (
  <Route path="ai/style-guide">
    <Route path="" element={<SettingsAIOptionsStyleGuideView />} />
    <Route
      path=":styleguideId"
      element={<SettingsAIOptionsStyleGuideEditView />}
    />
    <Route path="create" element={<SettingsAIOptionsStyleGuideCreateView />} />
  </Route>
);
